<svg class="bottom-px relative align-text-bottom" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    id="oval"
    fill="currentColor"
    d="M6.83534 0.206059C4.4833 0.761675 3.12455 2.36147 2.26245 3.38649C1.33475 4.47856 0.200901 5.79096 0.0228583 7.82184C-0.108331 9.40247 0.33209 11.0406 1.16608 12.3626C3.03084 15.3227 6.62918 16.386 9.90892 15.8783C11.5582 15.6196 13.348 14.9586 14.4631 13.6271C15.9717 11.8357 15.9905 9.69944 15.9999 8.8277C16.0186 5.59937 14.2475 1.65258 10.846 0.397651C8.98122 -0.282501 7.30387 0.0911034 6.83534 0.206059Z"
  />
  <text
    class="font-main text-xs fill-white"
    stroke="null"
    font-family="Helvetica, Arial, sans-serif"
    font-size="10"
    font-weight="600"
    id="txt"
    x="50%"
    y="50%"
    dominant-baseline="central"
    text-anchor="middle"
    fill-opacity="null"
    stroke-opacity="null"
    stroke-width="0"
  >
    {{ index }}
  </text>
</svg>
